// Eine Kette für Anfragen, die nacheinander laufen müssen. Herausgelöst aus
// AbwaegenStudio.jsx (23.09.2026), damit Desktop und Handy dieselbe benutzen.
//
// Warum: "Passt", Kommentare und KI-Runden schreiben dieselbe Sitzung. Laufen
// zwei gleichzeitig, lesen beide denselben Stand, und der zweite
// Schreibvorgang verwirft den ersten. Jede Aufgabe startet deshalb erst, wenn
// die vorige fertig ist - auch dann, wenn die vorige fehlgeschlagen ist.

/**
 * @returns {{ reihe: (aufgabe: () => any) => Promise<any> }}
 *   reihe() hängt eine Aufgabe an. Ihr Ergebnis bzw. ihr Fehler kommt beim
 *   Aufrufer an; die Kette selbst läuft in jedem Fall weiter.
 */
export function erstelleKette() {
  let ende = Promise.resolve();
  return {
    reihe(aufgabe) {
      const lauf = ende.then(() => aufgabe());
      ende = lauf.catch(() => {});
      return lauf;
    },
  };
}
